'use strict';

var _ = require('lodash');
var SaveExclusionsPopupController = function SaveExclusionsPopupController($scope, userSecureService) {
  $scope.popupVisible = false;
  $scope.selectedProductGroup = 'ALL';
  $scope.toggleModal = function () {
    $scope.popupVisible = !$scope.popupVisible;
  };
  $scope.closeModal = function () {
    $scope.popupVisible = false;
  };
  $scope.saveExclusionsButtonDisabled = function () {
    return $scope.modifiedBars.length === 0 || !userSecureService.hasAuthorization('demand-transparency', 'write');
  };
  $scope.onSaveClick = function () {
    $scope.$emit('demand-transparency:save-selected-exclusion', $scope.selectedProductGroup);
    $scope.closeModal();
  };
  $scope.$watch('quickFilterData', function () {
    if (!_.isNil($scope.quickFilterData) && !_.isNil($scope.quickFilterData.classGroup)) {
      $scope.selectedProductGroup = $scope.quickFilterData.classGroup;
    }
  });
};
SaveExclusionsPopupController.$inject = ['$scope', 'UserSecureService'];
module.exports = SaveExclusionsPopupController;